import MeetingsCopy from '../copy/meetings';
import MessagesCopy from '../copy/messages';
import FeedbackCopy from '../copy/days-feedback';

export const returnUpdatedScores = (previousScores, gameScores) => {
    return {
        party: previousScores.party + gameScores.party,
        voters: previousScores.voters + gameScores.voters,
        media: previousScores.media + gameScores.media,
    };
};

export const selectRandomArrayEntry = array => {
    return array[Math.floor(Math.random() * array.length)];
};

export const shuffleArray = array => {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }

    return array;
};

export const getMessagesOrMeetings = (party, difficulty, game) => {
    const copy =
        game === 'meetings'
            ? MeetingsCopy.meetings[difficulty]
            : MessagesCopy.messages;

    const unshuffledArray = copy.reduce((arr, entry, i) => {
        if (
            entry.party === party ||
            entry.party === 'neutral' ||
            party === 'all'
        ) {
            return [...arr, i];
        } else return arr;
    }, []);
    return shuffleArray(unshuffledArray);
};

export const returnDebateScores = (results, points) => {
    return results.reduce((obj, result) => {
        if (result => result.pointsReached === points) {
            return {
                ...obj,
                scores: {
                    party: result.score_party,
                    voters: result.score_local,
                    media: result.score_media,
                },
                feedback: result.feedback,
            };
        }

        return obj;
    }, {});
};

const parties = {
    'Governing Party': 'government',
    'Opposing Party': 'opposition',
};

export const returnPartyString = party => {
    return parties[party];
};

export const getDaysFeedback = scores => {
    switch (true) {
        case scores.media >= 0 && scores.party >= 0 && scores.voters >= 0:
            return FeedbackCopy['politically-polished'];
        case scores.media < 0 && scores.party >= 0 && scores.voters >= 0:
            return FeedbackCopy['old-school-pro'];
        case scores.media >= 0 && scores.party >= 0 && scores.voters < 0:
            return FeedbackCopy['future-frontbencher'];
        case scores.media >= 0 && scores.party < 0 && scores.voters >= 0:
            return FeedbackCopy['lovable-maverick'];
        case scores.media < 0 && scores.party >= 0 && scores.voters < 0:
            return FeedbackCopy['party-pleaser'];
        case scores.media < 0 && scores.party < 0 && scores.voters >= 0:
            return FeedbackCopy['local-hero'];
        case scores.media >= 0 && scores.party < 0 && scores.voters < 0:
            return FeedbackCopy['media-savvy'];
        case scores.media < 0 && scores.party < 0 && scores.voters < 0:
            return FeedbackCopy['poor-performer'];
        default:
            return FeedbackCopy['lovable-maverick'];
    }
};
